import { memo, useMemo } from "react";
import MainApi from "../../../../../services/mainApi.service";
import { AutoComplete, ISelectType } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

const translationPath = "page.4uBus.register.iService.";

export const MethodType = memo(() => {
  const { t } = useTranslation();

  const params = useMemo(() => ({ Identifier: "IServiceMethodType" }), []);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        params={params}
        name="methodType"
        label={t(translationPath + "method_type") || "Method Type"}
        getOptionLabel={(option) => option.name}
        fullWidth
        size="small"
        request={genericService.list}
      />
    </Grid>
  );
});
